var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "syf-component-library/ui/spacing";
import { InlineTip } from "./InlineTip";
import { TipAccordion } from "./TipAccordion";
var Tip = function (_a) {
    var reason = _a.reason, id = _a.id;
    var description = reason.description, explanation = reason.explanation, resolution = reason.resolution;
    if (!description)
        return null;
    if (!explanation && !resolution) {
        return _jsx(InlineTip, __assign({ id: id }, { children: description }));
    }
    return _jsx(TipAccordion, { id: id, reason: reason });
};
var getTipId = function (_a) {
    var reasonCode = _a.reasonCode, description = _a.description;
    return "tip-".concat(reasonCode !== null && reasonCode !== void 0 ? reasonCode : description);
};
var TipAccordions = function (_a) {
    var reasons = _a.reasons;
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "large" }), reasons === null || reasons === void 0 ? void 0 : reasons.map(function (reasonData) {
                var id = getTipId(reasonData);
                return _jsx(Tip, { id: id, reason: reasonData }, id);
            })] }));
};
export default TipAccordions;
